<template
  src="./invoicePopupComponentForCorporateDashboard.template.html"
></template>
<script>
import moment from "moment-timezone";
// import html2pdf from "html2pdf.js";
import { tempoBase64, rentalsUnitedBase64, airbnbBase64, bookingComBase64, homeBase64, expediaBase64, tripadvisorBase64, siteMinderBase64, travelStaytionBase64, bookingButtonBase64, hotelsBase64, uk_hotels_com_Base64, hopperBase64, vrboBase64 } from './sourceUrls.js';

export default {
  name: "invoicePopupComponentForCorporateDashboard",
  props: [
    "guestInfo",
    "roomInfo",
    "additionalEmails",
    "folioItemsDetails",
    "actualMyValue",
    "selectedLedger",
    "Reservation_Status",
    "balanceTransferDetails",
    "parentComp",
    "getTotalAmount",
    "totalAmountVal",
    "totalBalanceTransfer",
    "totalTaxVal",
    "corporateDetails",
    "corporateEmail",
    "corporatePhoneNo",
    "companyProfileId",
    "clientId",
    "isMasterFolioAvailable",
    "selectedInvoiceObj",
    "selecteditems",
    "editable",
    "invoicedetails1"
  ],
  data() {
    return {
      DetailedOrConsolidated: null,
      invoiceDetails: {},
      emailList: [],
      apiUrl:
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":1339" : ""),
      tableRows: [], // Initialize with empty tableRows
      showEmptyRow: false, // Flag to show/hide empty row
      newRowDate: "", // Data binding for new row's date
      items: [],
      displayedContent: "",
      localBalanceTransferDetails: [],
      clientLogo: ''

    };
  },
  methods: {
    addItem() {
      this.items.push({ name: "", description: "", Amount:'',Tax: '', Total: ''  });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    removeExistingItem(index) {
        if (this.localBalanceTransferDetails.length === 1) {
            // If it's the last item, reset the array to an empty one
            this.localBalanceTransferDetails = [];
        } else {
            this.localBalanceTransferDetails.splice(index, 1);
        }
    },
    getGuestAddress(guestDetail) {
      const { CityName, StateName, ZipCode } = guestDetail;
      const addressArr = [CityName, StateName, ZipCode].filter(Boolean);
      return addressArr.join(", ");
    },
    getCorporateDetails(corporateDetails) {
      const { CityName, StateName, PostalCode } = corporateDetails;
      const addressArr = [CityName, StateName, PostalCode].filter(Boolean);
      return addressArr.join(", ");
    },
    getPropertyAddress(propertyDetail) {
      const { cityName, stateName, ZipCode } = propertyDetail;
      const addressArr = [cityName, stateName, ZipCode].filter(Boolean);
      return addressArr.join(", ");
    },
    getClientAddress(clientDetail) {
      const { ClientCity, ClientState, ClientZipCode } = clientDetail;
      const addressArr = [ClientCity, ClientState, ClientZipCode].filter(
        Boolean
      );
      return addressArr.join(", ");
    },
    getFolioInvoice(value) {
      let vm = this;
      console.log("vm.guestInfo.ReservationId---getFolioInvoice", vm.selectedInvoiceObj.FolioId);
      vm.DetailedOrConsolidated = value;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetFolioLedgerTransDetails_Invoice",
        params: {
          FunctionId: null,
          ReservationId: vm.guestInfo.ReservationId,
          companyProfileId: vm.companyProfileId,
          folioId: vm.selectedInvoiceObj && vm.selectedInvoiceObj.FolioId ? vm.selectedInvoiceObj.FolioId : null,
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in GetFolioLedgerTransDetails_Invoice", err);
            return;
          }
          if (response) {
            console.log(
              "result in GetFolioLedgerTransDetails_Invoice",
              response
            );
            vm.invoiceDetails = response;
            console.log("vm.invoiceDetails====>thimmappa", response);
            for (var i in vm.additionalEmails) {
              if (!vm.additionalEmails[i].Emailaddress) {
                vm.additionalEmails.splice(i, 1);
              }
            }
            if (vm.additionalEmails.length == 0) {
              vm.additionalEmails.push({ ReservationId: "", Emailaddress: "" });
            }
          }
        },
      });
    },
    closeInvoicePopup() {
      console.log("account doc click");
      $(".modal-backdrop.fade.in").remove();
      $(".modal-backdrop.fade.show").remove();
    },
    closeEmailDropdown() {
      let vm = this;
      vm.emailList = [];
      // vm.showEmailDropdown = false;
    },
    sendPdfEmail() {
      let vm = this;
      if (vm.emailList[0] == "" || vm.emailList[0] == null) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "Please save guest email to send Invoice.",
        });
        return;
      }
      vm.isModalVisible = false;
      vm.$store.dispatch("dataRequestHandler", {
        key: "sendInvoiceMail",
        params: {
          invoiceDetails: vm.invoiceDetails,
          imgUrl: vm.apiUrl + "/downloadImage/",
          email: vm.emailList,
          folioItemSummary: vm.folioItemsDetails,
          DetailedOrConsolidated: vm.DetailedOrConsolidated,
          ShowTaxdetailsonDetailedInvoice:
            vm.guestInfo.ShowTaxdetailsonDetailedInvoice,
          ShowPolicyonDetailedInvoice: vm.guestInfo.ShowPolicyonDetailedInvoice,
          parentComp: vm.parentComp,
          balanceTransferDetails: vm.balanceTransferDetails,
          totalBalanceTransfer: vm.totalBalanceTransfer,
          selectedInvoiceObj: vm.selectedInvoiceObj[0],
          isMasterFolioAvailable: vm.isMasterFolioAvailable,
          additionalCompanyDetails: {
            createdTransferDate:
              vm.balanceTransferDetails &&
              vm.balanceTransferDetails[0].CreatedDate,
            invoiceNo:
              vm.balanceTransferDetails &&
              vm.balanceTransferDetails[0].QuickbookInvoiceNo &&
              vm.balanceTransferDetails[0].QuickbookInvoiceNo != null
                ? vm.balanceTransferDetails[0].QuickbookInvoiceNo
                : vm.balanceTransferDetails[0].InvoiceNo,
            corporateAddress: vm.corporateDetails.Address,
            corporateCity: vm.corporateDetails.CityName,
            corporateState: vm.corporateDetails.StateName,
            corporateCountry: vm.corporateDetails.CountryName,
            postalCode: vm.corporateDetails.PostalCode,
            companyName: vm.corporateDetails.GuestFirstName,
            companyEmail:
              vm.corporateEmail && vm.corporateEmail[0].Emailaddress,
            companyPhnNo:
              vm.corporatePhoneNo && vm.corporatePhoneNo[0].PhoneNumber,
            actualTransferDate:
              vm.balanceTransferDetails &&
              vm.balanceTransferDetails[0].DateEffective,
          },
        },
        callback: function (err, response) {
          if (err) {
            console.log("err in sendInvoiceMail", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "Error",
              message: "Error While sending Invoice mail!",
            });
            return;
          }
          if (response) {
            console.log("response in sendPdf", response);
            vm.emailList = [];
            if (response.errorMessage == "") {
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Email Sent Succesfully!",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "Error While sending Invoice mail!",
              });
            }
          }
        },
      });
    },
    imageURLS(imgGuid) {
      let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
      if (isBase64) {
        return imgGuid;
      }
      return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
    },
    async fetchClientLogo() {
      if (this.invoiceDetails.clientDetail && this.invoiceDetails.clientDetail.ClientLogo && this.invoiceDetails.clientDetail.ClientLogo !== 'null') {
        this.clientLogo = await this.convertImageToBase64(this.invoiceDetails.clientDetail.ClientLogo);
      }
    },
    async convertImageToBase64(imgGuid) {
      const imageUrl = `${this.apiUrl}/downloadImage/${imgGuid}/430x300`;
      
      try {
        const response = await fetch(imageUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
     
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          
          reader.onloadend = () => {
            if (reader.result) {
              const base64Image = reader.result; // Base64 string
              // console.log('base64Image:', base64Image);
              resolve(base64Image);
            } else {
              console.error('Failed to convert blob to Base64');
              reject('Failed to convert blob to Base64');
            }
          };
    
          reader.onerror = () => {
            reject('Error reading the blob as Base64');
          };
     
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error('Error fetching or converting image:', error);
        throw error;
      }
    },
    formatMoney(amount) {
      return this.$store.state.getFormattedAmount("$", amount);
    },
    formatDate(date) {
      console.log("date====>", date);
      let vm = this;
      return moment(date).format("DD MMM YYYY");
    },
    formatInvoiceUtcDate(date) {
      let vm = this;
      return moment.utc(date).format("DD MMM YYYY");
    },
    getLastTwoDigits(date) {
      let vm = this;
      return date.toString().substr(-2);
    },
    propagation(event) {
      event.stopPropagation();
    },
    sharePdf() {
      let vm = this;

      if (vm.corporateEmail.length == 1) {
        vm.emailList = vm.corporateEmail[0].Emailaddress.split();
        vm.sendPdfEmail();
      }
    },
    pdfDownload1() {
        const items=this.selectedInvoiceObj;
        // this.selectedInvoiceObj=items;
        this.ReservationId=items.ReservationId
        this.clientId=items.ClientId;
        this.companyProfileId=items.CompanyProfileId
        const parentComp = 'guestProfile'

        // console.log("thimmapp",items)
        // console.log("thimmappa1",this.additionalEmails.Emailaddress) 
                const {
                    actualMyValue,
                    // selectedLedger,
                    apiUrl,
                    // DetailedOrConsolidated,
                    guestInfo,
                    // companyProfileId,
                    // clientId,
                    
                    balanceTransferDetails,
                    corporateDetails,
                    corporateEmail,
                    corporatePhoneNo,
                    totalBalanceTransfer,
                    selectedInvoiceObj,
                    isMasterFolioAvailable,
                } = this;
                // console.log("guestInfo==================>",guestInfo)
                const additionalCompanyDetails = {
                    createdTransferDate: balanceTransferDetails ? balanceTransferDetails[0].CreatedDate : null,
                    invoiceNo: balanceTransferDetails && balanceTransferDetails[0].InvoiceNo && balanceTransferDetails[0].InvoiceNo != null ? balanceTransferDetails[0].InvoiceNo : '',
                    corporateAddress: guestInfo.CompanyProfileAddress1,
                    corporateCity: guestInfo.CompanyProfileCity,
                    corporateState: guestInfo.CompanyProfileState,
                    corporateCountry: guestInfo.CompanyProfileCountryName,
                    postalCode: guestInfo.CompanyPostalCode,
                    companyName: guestInfo.CompanyProfileName,
                    companyEmail: guestInfo.CompanyEmail ? guestInfo.CompanyEmail :'' ,
                    companyPhnNo: guestInfo.CompanyPhoneNumber ? guestInfo.CompanyPhoneNumber :''
                }

                const form = document.createElement("form");

                const createInput = (name, value, hidden = true) => {
                    const input = document.createElement("input");
                    input.name = name;
                    input.value = value;
                    input.hidden = hidden;
                    return input;
                };

                const appendInput = (name, value, hidden = true) => {
                    form.appendChild(createInput(name, value, hidden));
                };

                appendInput("ReservationId",  this.ReservationId);
                appendInput("ClientId", this.clientId);
                appendInput("companyProfileId", this.companyProfileId);
                appendInput("imgUrl", `${apiUrl}/downloadImage/`);
                // appendInput("ledgerAccountId", selectedLedger?.ledgerAccountID || null);
                appendInput("ledgerAccountId", null);
                // appendInput("Amount", selectedLedger?.defaultAmount || selectedLedger?.TaxAmount || null);
                appendInput("Amount",  null);
                // appendInput("DateEffective", selectedLedger ? moment(selectedLedger.dateEffective).format("YYYY-MM-DD") : null);
                appendInput("DateEffective", null);
                // appendInput("IsFolioEdit", selectedLedger && selectedLedger.dateEffective != null ? 1 : 0);
                appendInput("IsFolioEdit", 0)
                // appendInput("DetailedOrConsolidated", DetailedOrConsolidated);
                appendInput("DetailedOrConsolidated", 2);
                appendInput("ShowTaxdetailsonDetailedInvoice", guestInfo.ShowTaxdetailsonDetailedInvoice);
                appendInput("ShowPolicyonDetailedInvoice", guestInfo.ShowPolicyonDetailedInvoice);
                appendInput("invoiceType", parentComp);
                appendInput("companyDetails", JSON.stringify(additionalCompanyDetails));
                appendInput("balanceTransferDetails", JSON.stringify(balanceTransferDetails));
                appendInput("totalBalanceTransfer", JSON.stringify(selectedInvoiceObj));
                appendInput("isMasterFolioAvailable", isMasterFolioAvailable);
                appendInput("folioId", selectedInvoiceObj.FolioId);
                form.method = "POST";
                form.action = `${this.$store.state.reportHttpUrl}/FolioInvoice1`;
                document.body.appendChild(form);
                form.submit();
            },
    pdfDownload(ReservationId) {
      const {
        actualMyValue,
        selectedLedger,
        apiUrl,
        DetailedOrConsolidated,
        guestInfo,
        companyProfileId,
        clientId,
        parentComp,
        balanceTransferDetails,
        corporateDetails,
        corporateEmail,
        corporatePhoneNo,
        totalBalanceTransfer,
        isMasterFolioAvailable,
        selectedInvoiceObj,
      } = this;
      const additionalCompanyDetails = {
        createdTransferDate: balanceTransferDetails
          ? balanceTransferDetails[0].CreatedDate
          : null,
        invoiceNo:
          balanceTransferDetails &&
          balanceTransferDetails[0].InvoiceNo &&
          balanceTransferDetails[0].InvoiceNo != null
            ? balanceTransferDetails[0].InvoiceNo
            : '',
        corporateAddress: corporateDetails.Address,
        corporateCity: corporateDetails.CityName,
        corporateState: corporateDetails.StateName,
        corporateCountry: corporateDetails.CountryName,
        postalCode: corporateDetails.PostalCode,
        companyName: corporateDetails.GuestFirstName,
        companyEmail: corporateEmail && corporateEmail[0].Emailaddress,
        companyPhnNo: corporatePhoneNo && corporatePhoneNo[0].PhoneNumber,
      };

      const form = document.createElement("form");

      const createInput = (name, value, hidden = true) => {
        const input = document.createElement("input");
        input.name = name;
        input.value = value;
        input.hidden = hidden;
        return input;
      };

      const appendInput = (name, value, hidden = true) => {
        form.appendChild(createInput(name, value, hidden));
      };

      appendInput("ReservationId", ReservationId);
      appendInput("ClientId", clientId);
      appendInput("companyProfileId", companyProfileId);
      appendInput("imgUrl", `${apiUrl}/downloadImage/`);
      appendInput("ledgerAccountId", selectedLedger?.ledgerAccountID || null);
      appendInput(
        "Amount",
        selectedLedger?.defaultAmount || selectedLedger?.TaxAmount || null
      );
      appendInput(
        "DateEffective",
        selectedLedger
          ? moment(selectedLedger.dateEffective).format("YYYY-MM-DD")
          : null
      );
      appendInput(
        "IsFolioEdit",
        selectedLedger && selectedLedger.dateEffective != null ? 1 : 0
      );
      appendInput("DetailedOrConsolidated", DetailedOrConsolidated);
      appendInput(
        "ShowTaxdetailsonDetailedInvoice",
        guestInfo.ShowTaxdetailsonDetailedInvoice
      );
      appendInput(
        "ShowPolicyonDetailedInvoice",
        guestInfo.ShowPolicyonDetailedInvoice
      );
      appendInput("invoiceType", parentComp);
      appendInput("companyDetails", JSON.stringify(additionalCompanyDetails));
      appendInput(
        "balanceTransferDetails",
        JSON.stringify(balanceTransferDetails)
      );
      appendInput(
        "totalBalanceTransfer",
        JSON.stringify(selectedInvoiceObj)
      );
      appendInput("isMasterFolioAvailable", isMasterFolioAvailable);
      appendInput("folioId", selectedInvoiceObj.FolioId);

      form.method = "POST";
      form.action = `${this.$store.state.reportHttpUrl}/FolioInvoice`;

      document.body.appendChild(form);
      form.submit();
    },
    wordDownload() {
      let isClicked = true;
      const invoiceNumber =
        this.invoiceDetails.reservationDetail.ConfirmationNumber;
      const element = this.$refs.editableContent;
      const htmlContent = element.innerHTML;
      const base64Images = {
        Tempo: tempoBase64,
        'Rentals United': rentalsUnitedBase64,
        Airbnb: airbnbBase64,
        'Booking.com': bookingComBase64,
        Home: homeBase64,
        Expedia: expediaBase64,
        Tripadvisor: tripadvisorBase64,
        SiteMinder: siteMinderBase64,
        TravelStaytion: travelStaytionBase64,
        BookingButton: bookingButtonBase64,
        Hotels: hotelsBase64,
        'uk.hotels.com': uk_hotels_com_Base64,
        Hopper: hopperBase64,
        Vrbo: vrboBase64,
        'Tempo Engine' : tempoBase64,
      };
      
      const getBackgroundStyle = (sourceName) => {
        return base64Images[sourceName] ? `background: #fff url(${base64Images[sourceName]}) no-repeat 28px 0px;` : '';
      };
      const styledHtmlContent = `
        <html>
          <head>
                    <style>

                    .corporateDetailStyle{
                        margin-top: 20px !important;
                    }
                    .sourceUrl[class*="${this.guestInfo.SourceName}"]{
                        left: -30px;
                        top:2px;
                        background-size: contain;
                    }
                    .sourceUrl[class*="${this.guestInfo.SourceName}"] {
                      ${getBackgroundStyle(this.guestInfo.SourceName)}
                    }
                    .personsCount{
                      margin-right: 60px !important;
                    }

                    @media print {

                            @import url("https://fonts.googleapis.com/css2?family=Calibri:wght@100;300;400;500;700;900&display=swap") print;
    
                            *{
                                font-family: Calibri !important;
                            }


                            html{
                                zoom: 0.75 !important;
                                font-family: Calibri !important;
                            }
                            body{
                                font-family: Calibri !important;
                                color:#000 !important;
                                letter-spacing: 0.07px !important;
                                background: #fff;
                            }

                            tr{ 
                                page-break-inside:avoid !important; 
                                page-break-after:auto !important;    
                            }

                            .pdfDetailedInvoice .cl1{
                                width: 99px !important;
                                white-space: nowrap;
                            }
                            .pdfDetailedInvoice .cl1.footer-cell{
                                white-space: nowrap;
                            }
                            .pdfDetailedInvoice .cl2 {
                                width: 275px !important;
                                text-align: left !important;
                            }
                            .pdfDetailedInvoice .cl1.pdf-tax-info{
                                white-space: nowrap;
                                position: absolute;
                            }
                            .pdf-invoice-policy-info span{
                                font-size: 10.1pt !important;
                                letter-spacing: 0.07px !important;
                                margin: 0 0 5px 0;
                                display: inline-block;
                            }
                            .pdf-sec-gap .footer-cell{
                                padding: 12px 2px !important;
                            }
                            .pdfPreAuth{
                                position: absolute;
                                right: 17px;
                                margin-top: 2px;
                                font-size: 10.5px;
                            }
                    }
            *{
                font-family: Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif !important;
                }

                body {font-family: 'calibri', sans-serif !important; margin-top: 0px;margin-left: 0px; color:#000; font-size: 10.1pt !important;}
                        .no-print {
                display: none !important;
                }
                .dateInvoiceInfoPDF{
                    width: 100% !important;
                    margin-top: 0 auto !important;
                    padding-top: 25px !important;
                }
                .dateInvoiceInfoPDF1{
                    width: 100% !important;
                    margin-top: 0 auto !important;
                    padding-top: 0 !important;
                }
                .fontsizepdf{
                   font-family: calibri,sans-serif !important; 
                     font-size: 8pt !important;
                      letter-spacing: 0.07px !important;
                     
                }
                .fontsizepdf1{
                   font-family:calibri,sans-serif !important;
                     font-size: 14pt !important;
                     font-weight: normal !important;
                      margin-bottom: 0;
                      line-height: 1.3 !important;
                      letter-spacing: 0.01px !important;
                }
                .clientInfo1{
                  font-size: 6.8pt;
                  letter-spacing: 0.07px !important;
                  white-space: normal;
                  word-break: break-all;
              }
                .fontsizepdf2{
                  font-family: Calibri !important;
                   font-size: 11pt !important;
                    font-weight: 700 !important;
                    margin-bottom: 0px !important;
                    margin-top: 0px !important;
                }
                .fontsizepdf3{
                   font-family: Calibri !important;
                    font-size: 11pt !important;
                     font-weight: 700 !important;
                     margin-bottom: 14px !important;
                     margin-top: 20px;
                }
                .fontsizepdf4{
                   font-family: Calibri !important;
                    font-size: 8pt !important;
                     font-weight: 700 !important;
                     margin-bottom: 6px;
                     margin-top: 20px;
                }
                .paddingtable1{
                  padding-left: 5px !important;
                }
                .fontsizepdf5{
                   font-family: Calibri !important;
                    font-size: 8pt !important;
                     font-weight: 700 !important;
                     margin-bottom: 6px;
                     margin-top: 20px;
                     background:  #ffffff !important;
                }
                .invoice-stay-table{
                        width: 100%;
                        margin-bottom: 20px;
                        font-size: 10.1pt !important;
                        color:#000 !important;
                        letter-spacing: 0.07px !important;
                        table-layout: fixed;
                    }
                    .sub-title{
                        font-family: Calibri !important;
                        font-size: 13pt !important; 
                        font-weight: 700 !important;
                        margin-bottom: 6px;
                        margin-top: 20px;	
                    }

                    .c1{
                        width: 112px;
                    }
                    .c2{
                        width: 250px;
                    }
                    .c3{
                        width: 100px;
                    }
                    .c4{
                        width: 96px;
                    }
                    .c5{
                        width: 115px;
                    }
                    .tr2-c2-pl{
                        padding-left: 7px;
                    }
                    .tr2-c4-va, .tr2-c5-va{
                        vertical-align: top;
                    }
                    .itr3-td-pt{
                        padding-top:15px;
                    }
                    .inv-sub-items{
                        float:right;
                    }
                    .sub-itr3-col1{
                        width: 90px;
                    }
                    // .sub-itr3-col2{

                    // }
                    .src-icon-pl{
                        padding-left: 6px;
                    }
                    .invoice-dec-table{
                        width: 100%;
                        font-size: 10.1pt !important;
                        color: #000 !important;
                        letter-spacing: 0.07px !important;
                    }
                    .editablerowwidth{
                      width: 99px !important
                    }
                    .editablerowwidth1{
                      width: 78px !important
                    }

                  
                    .cl2{
                        width: 55px;
                    }
                    .cl3{
                        width: 100px;
                    }
                    .cl4{
                        width: 90px;
                    }
                    .cl5{
                        width: 100px;
                    }
                    .tx-rt{
                        text-align: right;
                    }
                    .tx-cntr{
                    text-align: center;
                    }
                   
                    .thead-cell:first-child{
                        padding: 9px 2px 9px 12px;
                    }
                    .thead-cell:last-child{
                        padding: 9px 12px 9px 2px;
                    }
                    .itemcell{
                        padding: 6px 2px;
                        vertical-align: top;
                    }
                    .itemcell:first-child{
                        padding: 6px 2px 6px 12px;
                    }
                    .itemcell:last-child{
                        padding: 6px 12px 6px 2px;
                    }
                    .footer-cell{
                        padding: 9px 2px;
                        background: #f5f5f5;
                        font-size: 10.2pt !important;
                        font-weight: 700;
                    }
                    .footer-cell:first-child{
                        padding: 6px 2px 6px 12px !important;
                        text-align: left;
                    }
                    .footer-cell:last-child{
                        padding: 6px 12px 6px 2px !important;
                    }
                    // .footer-cell.double-ln{
                    //     border-top: 3px double #000;
                    // }
                
                    .invo-client-info{
                        font-size: 10.1pt !important;
                        padding-left: 69px;
                        padding-top: 30px !important;
                        line-height: 1.2;
                        letter-spacing: 0.07px !important;

                        h5{
                            display: inline-block;
                            font-family: Calibri !important;
                            font-size: 13pt !important;
                            font-weight: 700 !important;
                            margin-bottom: 0;
                        }
                    }

                    .Cell-3{
                        flex-grow: 0.2 !important;
                    }
                    .Cell-4 {
                        flex-grow: 0.2 !important;
                    }
                    .td-lh{
                        line-height: 1.2;
                    }

                    .invoice-policy-info{
                        span{
                            font-size: 10.1pt !important;
                            color: #000 !important;
                            letter-spacing: 0.07px !important;
                            margin: 0 0 5px 0;
                            display: inline-block;
                        }
                    }
                    .detailedInvoice{
                        .cl1{
                            //width: 123px;
                            width: 170px;
                        }  
                        .cl2{
                            width: 230px;
                        }
                        .cl2{
                            text-align: left;   
                        }
                        .cl1.tax-info{
                            white-space: nowrap;
                            position: absolute;
                        } 
                        .cl1.footer-cell{
                            white-space: nowrap;
                            position: absolute;
                            margin-top: 0px;
                            // border-top: 1px solid #000;
                        } 
                    }
                    .sub-t-head-row{
                        .itemcell{
                            background: #f5f5f5;
                            padding: 9px 2px 9px 9px;
                        }
                        .itemcell:last-child{
                            padding: 9px 12px 9px 2px;
                        }
                    }
                    .itemcell1{
                            background: #f5f5f5;
                           
                        }
                    .t-head-row{
                        border-bottom: 1px solid #000;
                    }
                     .thead-cell{
                        border-bottom: 1px solid #000;
                    }

                   
                        .footer-cell{
                            background: unset;
                            padding: 6px 2px;
                            border-top: 1px solid #999;
                            border-bottom: 1px solid #999;
                            font-family: Calibri !important;
                    font-size: 8pt !important;
                     font-weight: 700 !important;
                        }
                    
                    .sec-gap .itemcell{
                        padding: 12px 2px;
                    }
                    .reming-bal-row {
                        .footer-cell{
                            padding: 9px 2px 9px 12px !important;
                            background: #f5f5f5;
                            border-top: 2px solid #000;
                            border-bottom: unset;
                        }
                        .footer-cell:first-child{
                            padding: 9px 2px 9px 12px !important;
                            margin-top: -1px;
                        }
                        .footer-cell:last-child{
                            padding: 9px 12px 9px 2px !important;  
                        }
                    }
                    .preAuth{
                        position: absolute;
                        right: 53px;
                        margin-top: 2px;
                        font-size: 10.5px;
                    }
                    .ciAddress::before{
                        content: ":";
                        width: 8px;
                        height: 14px;
                        position: absolute;
                        top: 0px;
                        left: 112px;
                    }
                    .itr1.posRelative{
                        position: relative;
                    }
                .invoStayInfo{
                        width: 85%;
                        margin: 0 auto;  
                    }
                    .non-editable {
                        pointer-events: none; 
                        .non-printable {
                    display: block; /* Ensure content is displayed normally */
                    }

                    @media print {
                    .non-printable {
                        display: none; /* Ensure content is not printed */
                    }
                    }
                    .boldsize{
                        font-family: calibri, sans-serif !important;
                         font-size: 1pt !important;
                          font-weight: normal !important;
                           letter-spacing: 0.07px !important;
                            margin-bottom: 0;"
                    }
                    .d1{
                        width: 99px;
                         text-align: left;
                          padding: 10px 2px 10px 12px !important;
                          font-size: 8pt !important;
                          font-weight: 700;
                          border-bottom: 1px solid #000 !important;
                    }
                    .d2{
                        width: 275px;
                         text-align: left;
                          padding: 10px 2px !important;
                          font-size: 8pt !important;
                          font-weight: 700;
                          border-bottom: 1px solid #000 !important;

                    }
                    .d3{
                        width: 95px;
                         text-align: right !important;
                          padding: 10px 2px !important;
                          font-size: 8pt !important;
                          font-weight: 700;
                          border-bottom: 1px solid #000 !important;

                    }
                    .d4{
                        width: 95px;
                         text-align: right !important;
                          padding: 10px 2px !important;
                          font-size: 8pt !important;
                          font-weight: 700;
                          border-bottom: 1px solid #000 !important;

                    }
                    .d5{
                        width: 95px;
                         text-align: right !important;
                          padding: 10px 12px 10px 2px !important;
                           font-size: 8pt !important;
                           font-weight: 700;
                           border-bottom: 1px solid #000 !important;
                    }
                    .thimmi{
                        display: none;
                    }
                    .bordersize{
                      border:none !important;
                    }
                    .bordercolapse{
                      border-right:0px solid white !important;
                    }
                       
            </style>
          </head>
          <body>
            ${htmlContent}
          </body>
        </html>
      `;
      const form = document.createElement("form");
      const createInput = (name, value) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        return input;
      };
      form.appendChild(createInput("htmlContent", styledHtmlContent));
      form.appendChild(createInput("invoiceNumber", invoiceNumber));
      form.appendChild(createInput("otherData", "Some other data"));

      form.method = "POST";
      form.action = `${this.$store.state.reportHttpUrl}/convert-to-pdf`;
      document.body.appendChild(form);
      form.submit();
    },
  },
  // created() {
  //   this.localBalanceTransferDetails = this.balanceTransferDetails.slice();
  // },
  created() {
    if (Array.isArray(this.balanceTransferDetails)) {
      this.localBalanceTransferDetails = this.balanceTransferDetails.slice();
    } else {
      this.localBalanceTransferDetails = [];
      console.warn('balanceTransferDetails is not an array:', this.balanceTransferDetails);
    }
  },
  watch: {
    guestInfo(newPropValue, oldPropValue) {
      this.getFolioInvoice(newPropValue.DefaultInvoiceType);
    },
    'invoiceDetails.clientDetail.ClientLogo': {
      immediate: true,
      handler(newVal) {
        this.fetchClientLogo();
      }
    }
  },
  computed: {},
  mounted() {
    let vm = this;
    vm.getFolioInvoice(vm.guestInfo.DefaultInvoiceType);
    $(document).click(function (e) {
      console.log("invocie popup doc click");
      // $("#invoiceToBePrinted").removeClass("show")
      // $(".menuMaskRevSum").hide();
      // $(".modal-backdrop").remove();
    });
  },
};
</script>
<style>
.dollorPriceAlignmnet {
  display: flex;
  justify-content: flex-end;
  white-space: normal;
  word-break: break-all;     
}
.personsCount{
  margin-right: 50px !important;
}
</style>
